<template>
  <div class="visualizer-exit-modal">
    <button
      class="visualizer-exit-modal__overlay"
      @click="$emit('close-exit-modal')"
    />
    <div class="visualizer-exit-modal__container">
      <button
        :aria-label="$string('accessibility.close')"
        class="visualizer-exit-modal__close"
        @click="$emit('close-exit-modal')"
        v-html="$icon('enclosed.close')"
      />
      <div class="visualizer-exit-modal__header">
        <h1>{{ $string('bedVisualizer.exitModal.title') }}</h1>
      </div>

      <div class="visualizer-exit-modal__description">
        <p class="body-1">
          {{ $string('bedVisualizer.exitModal.description') }}
        </p>
      </div>

      <div class="visualizer-exit-modal__actions">
        <btn
          class="visualizer-exit-modal__action"
          modifiers="block inverse secondary center small"
          :icon="false"
          :label="$string('bedVisualizer.exitModal.continue')"
          @click="$emit('close-exit-modal')"
        />
        <btn
          v-if="enableSave"
          class="visualizer-exit-modal__action"
          modifiers="block inverse secondary center small"
          :icon="false"
          :label="$string('bedVisualizer.exitModal.save')"
          @click="$emit('save')"
        />
        <btn
          class="visualizer-exit-modal__action"
          modifiers="block inverse outlined center small"
          :icon="false"
          :label="$string('bedVisualizer.exitModal.exit')"
          @click="$emit('close-bed-visualizer')"
        />
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Visualizer exit modal (visualizer-exit-modal)
 * -----------------------------------------------------------------------------
 * A modal that appears when the user selects save and exit. This modal will prompt the user to continue, save for later, or exit.
 *
 */


export default {
  name: 'VisualizerExitModal',

  props: {
    enableSave: {
      type: Boolean,
      default: false,
    },
  },

  emits: [
    'close-exit-modal', 'close-bed-visualizer', 'save',
  ],
}
</script>

<style lang="scss">
@import './visualizer-exit-modal';
</style>
